export const numberWithCommas = function (x, decimalPlaces = 0) {

  var amount = x !== null || x !== undefined ? x : 0

  if(isNaN(amount))
  amount = 0
  
  return amount
  .toFixed(decimalPlaces)
  .toString()
  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

